import camelcaseKeys from 'camelcase-keys'
import { getFileURL } from '@/lib/helpers/FileURLGetter'


export class PageObjectLocation {
  constructor (params = {}) {
    const { id, name, facilityId, imageFileId } = camelcaseKeys(params ? params : {})
    this.id = id
    this.name = name || []
    this.facilityId = facilityId || null
    this.imageFileId = imageFileId || null
    this.imageFile = imageFileId ? getFileURL(imageFileId) : null
  }
}
